import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Planning } from 'src/app/classes/planning.class';
import { CodaltComponent } from 'src/app/codalt.component';
import { EntityType } from 'src/app/services/entities/entity-type.class';
import { DayReportStateService } from './day-report-state.service';

@Component({
    selector: 'app-day-report',
    templateUrl: './day-report.component.html',
    styleUrls: ['./day-report.component.scss'],
    standalone: false,
})
export class DayReportComponent extends CodaltComponent implements OnInit {
    begindate: Date | undefined;
    enddate: Date | undefined;
    planning: Planning | undefined;
    mainEntityType: EntityType | undefined;

    constructor(
        private activatedRoute: ActivatedRoute,
        private stateService: DayReportStateService
    ) {
        super();
    }

    ngOnInit(): void {
        this.subscriptions.add(
            this.activatedRoute.params.subscribe(params => {
                if (!params.planningId) {
                    return;
                }

                const planningId = Number(params.planningId);

                this.subscriptions.add(this.stateService.loadByPlanningId(planningId));
            })
        );

        this.subscriptions.add(
            this.stateService.planning$.subscribe(planning => {
                if (!planning) {
                    return;
                }

                this.planning = planning;
                this.begindate = planning.mainPlanning?.begindate;
                this.enddate = planning.mainPlanning?.enddate;
                this.mainEntityType = planning.mainPlanning
                    ? this.entitytypes[planning.mainPlanning.entitytype_key]
                    : undefined;
            })
        );
    }
}
